module.exports = __webpack_public_path__ + "fonts/MD5.041209ad.ttf";